import Header from "components/header";
import Footer from "components/footer/Footer";
import React from "react";
import { useLocation, Outlet } from "react-router-dom";
import routes from "routes";
import { RootState } from "reducers";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch } from "store";
import { fetchAppConfigRequest } from "actions";

export default function MainLayout(props: { [x: string]: any }) {
  const { ...rest } = props;
  const location = useLocation();

  const dispatch = useDispatch<AppDispatch>();
  const { config } = useSelector((state: RootState) => state.app);

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [open, setOpen] = React.useState(true);
  const [currentRoute, setCurrentRoute] = React.useState("Main Dashboard");

  React.useEffect(() => {
    window.addEventListener("resize", () =>
      window.innerWidth < 1200 ? setOpen(false) : setOpen(true)
    );
  }, []);
  React.useEffect(() => {
    getActiveRoute(routes);
  }, [location.pathname]);

  React.useEffect(() => {
    config?.theme === "light"
      ? document.body.classList.remove("dark")
      : document.body.classList.add("dark");
  }, [config?.theme]);

  // dispatch fetch app config
  React.useEffect(() => {
    if (!config) {
      dispatch(fetchAppConfigRequest());      
    }
  }, [config, dispatch]);

  const getActiveRoute = (routes: RoutesType[]): string | boolean => {
    let activeRoute = "Main Dashboard";
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(
          routes[i].layout + "/" + routes[i].path
        ) !== -1
      ) {
        setCurrentRoute(routes[i].name);
      }
    }
    return activeRoute;
  };

  const getActiveNavbar = (routes: RoutesType[]): string | boolean => {
    let activeNavbar = false;
    for (let i = 0; i < routes.length; i++) {
      if (
        window.location.href.indexOf(routes[i].layout + routes[i].path) !== -1
      ) {
        return routes[i].secondary;
      }
    }
    return activeNavbar;
  };
  // const getRoutes = (routes: RoutesType[]): any => {
  //   return routes.map((prop, key) => {
  //     if (prop.layout === "") {
  //       return (
  //         <Route path={`/${prop.path}`} element={prop.component} key={key} />
  //       );
  //     } else {
  //       return null;
  //     }
  //   });
  // };

  document.documentElement.dir = "ltr";
  return (
    <div className="text-small flex min-h-screen flex-col bg-lightPrimary text-gray-900 dark:bg-black dark:text-white">
      <Header
        onOpenSidenav={() => setOpen(true)}
        brandText={currentRoute}
        secondary={getActiveNavbar(routes)}
        {...rest}
      />
      {/* Main Content */}
      <main className="mt-[72px] h-full flex-none transition-all">
        {/* Routes */}
        <div className="min-h-full">
          {/* <Routes>
            {getRoutes(routes)}
          </Routes> */}
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
}
